import { isNil } from 'lodash';

import { Nullable } from '@/utils/ts-helpers';

// indicates which bits in the status byte actually correspond to an error
const errorBitsMap = [
    {
        // bit 1 is any SD error, including card full and card missing > NOT SYSTEM ERROR, EITHER SEPARATE SD ICON ON FRONTEND OR SIMPLY NOT NOTIFY USER
        isSystemError: false,
        description: `Device indicates any SD error, including card full and card missing > NOT SYSTEM ERROR`,
    },
    {
        // bit 2 is any system gps error (module isn't working, initialization failure) > SYSTEM ERROR
        isSystemError: true,
        description: `Device indicates any system gps error (module isn't working, initialization failure)`,
    },
    {
        // bit 3 is gps signal error (no signal) > NOT SYSTEM ERROR, (since we don't know what is causing it, system could be inside)
        isSystemError: false,
        description: `Device indicates a gps signal error (no signal) > NOT SYSTEM ERROR, (since we don't know what is causing it, system could be inside)`,
    },
    {
        // bit 4 is a signal pipeline error > SYSTEM ERROR (not sure, @evan, I assume this is serious?)
        isSystemError: true,
        description: `Device indicates a signal pipeline error`,
    },
    {
        // bit 5 is a charger configuration error (can happen momentarily if i2c is browned out during a config attempt, keeps re-trying > NOT SYSTEM ERROR (not critical if dusk/dawn brownout, nothing we can do about it, and no need to alarm user; if we can exclude the known brownout issue, then we can bring this back as a system error)
        isSystemError: false,
        description: `Device indicates a charger configuration error (can happen momentarily if i2c is browned out during a config attempt, keeps re-trying > NOT SYSTEM ERROR (not critical if dusk/dawn brownout, nothing we can do about it, and no need to alarm user; if we can exclude the known brownout issue, then we can bring this back as a system error)`,
    },
    {
        // bit 6 is an i2c power monitor error (monitor doesn't work, not anything to do with acceptable power ranges) > NOT SYSTEM ERROR (unless we can narrow it down to when it indicates something else than the known errors we sometimes get during brownout; the dusk/dawn brownout should not be notified to user)
        isSystemError: false,
        description: `Device indicates an i2c power monitor error (monitor doesn't work, not anything to do with acceptable power ranges) > NOT SYSTEM ERROR (unless we can narrow it down to when it indicates something else than the known errors we sometimes get during brownout; the dusk/dawn brownout should not be notified to user)`,
    },
    {
        // bit 7 is power rail out of spec. This is almost always low solar voltage, but also includes more serious errors > NOT SYSTEM ERROR, UNLESS SOLAR VOLTAGE IS HIGH
        isSystemError: false,
        description: `Device indicates power rail out of spec. This is almost always low solar voltage, but also includes more serious errors > NOT SYSTEM ERROR, UNLESS SOLAR VOLTAGE IS HIGH`,
    },
    {
        // bit 8 is charger isn't charging (not unexpected at night) > NOT SYSTEM ERROR (question: could we compare to solar voltage to see if night or day?)
        isSystemError: false,
        description: `Device indicates charger isn't charging (not unexpected at night) > NOT SYSTEM ERROR (question: could we compare to solar voltage to see if night or day?)`,
    },
];

export const checkForSystemError = (status?: Nullable<number>) => {
    if (isNil(status)) {
        return { hasError: false, description: '' };
    }
    for (let i = 0; i < 8; i++) {
        const bitSet = ((status >> i) & 1) === 1;
        if (errorBitsMap[i].isSystemError && bitSet) {
            return { hasError: true, description: errorBitsMap[i].description };
        }
    }
    return { hasError: false, description: '' };
};
